// Canonical Bio marker — Material `eco` leaf in a tertiary-container circle.
// Never a 'BIO' pill (design-system rule). Promoted here from a local copy in
// verwaltung/kostenstellen so every module renders the Bio indicator the same way.

interface BioLeafProps {
  isOrganic: boolean
  /** True when the Bio flag was inferred from the name rather than supplier data. */
  isRegexDerived?: boolean
  /** Overrides the default tooltip (e.g. to name the source of a manually set value). */
  title?: string
}

export function BioLeaf({ isOrganic, isRegexDerived = false, title }: BioLeafProps) {
  if (!isOrganic) return null
  const tooltip = title ?? (isRegexDerived ? 'Bio-Kennzeichnung aus Artikelname abgeleitet.' : 'Bio')
  return (
    <span
      title={tooltip}
      className="inline-flex items-center justify-center size-5 rounded-full bg-tertiary-container"
      aria-label="Bio"
    >
      <span className="material-symbols-outlined !text-[13px] text-on-tertiary-container" aria-hidden="true">eco</span>
    </span>
  )
}
